/**
 * Learn Articles - Load More Functionality
 * 
 * Implements AJAX-based pagination for blog articles using Shopify's native
 * paginate system. Loads additional articles without page refresh when the
 * "Load More" button is clicked.
 * 
 * @requires DOMParser API
 * @requires Fetch API
 * 
 * HTML Requirements:
 * - Button with id="load-more-btn" and data-next-url attribute
 * - Container with id="articles-grid" for article cards
 * - Spinner element with id="loading-spinner"
 * 
 * @version 2.0.0
 */

(function () {
  'use strict';

  // Cache DOM elements
  const loadMoreBtn = document.getElementById('load-more-btn');
  const articlesGrid = document.getElementById('articles-grid');
  const loadingSpinner = document.getElementById('loading-spinner');

  /**
   * Load more articles via AJAX
   * @param {string} nextUrl - URL of the next page to load
   */
  function loadMoreArticles(nextUrl) {
    if (!nextUrl) return;

    // Update UI: Hide button and show loading spinner
    loadMoreBtn.style.display = 'none';
    loadingSpinner.style.display = 'block';

    // Fetch the next page of articles
    fetch(nextUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((data) => {
        // Parse the HTML response into a document object
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        // Extract new article cards from the fetched page
        const newArticles = doc.querySelectorAll('#articles-grid .article__card');

        // Append each new article to the existing grid
        newArticles.forEach((article) => {
          articlesGrid.appendChild(article);
        });

        // Check if there are more pages available
        const newLoadMoreBtn = doc.getElementById('load-more-btn');

        if (newLoadMoreBtn) {
          // Update button with next page URL and show it
          const newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
          loadMoreBtn.setAttribute('data-next-url', newNextUrl);
          loadMoreBtn.style.display = 'inline-block';
        }
        // If no button found, keep it hidden (no more pages)

        // Hide loading spinner
        loadingSpinner.style.display = 'none';
      })
      .catch((error) => {
        // Handle fetch errors
        console.error('Error loading more articles:', error);
        loadingSpinner.innerHTML = 'Error loading articles. Please try again.';

        // Reset UI after 3 seconds
        setTimeout(() => {
          loadMoreBtn.style.display = 'inline-block';
          loadingSpinner.style.display = 'none';
          loadingSpinner.innerHTML = 'Loading...';
        }, 3000);
      });
  }

  /**
   * Initialize Load More functionality
   */
  function initLoadMore() {
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', function () {
      const nextUrl = this.getAttribute('data-next-url');
      loadMoreArticles(nextUrl);
    });
  }

  /**
   * Initialize all functionality
   */
  function init() {
    initLoadMore();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();